import axios from 'axios';
import { RECTORAL_API } from './service';

export const getSponsors = () => {
    const url = `${RECTORAL_API}/supporters`;
    const response: any = axios.get(url);
    return response;
};
